// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import stylesDef from './styles';

interface ViewerTokenErrorProps {
  onRetry: () => void;
}

// The viewer's map area when the ArcGIS token could not be had: what happened, and a way to try again.
export const ViewerTokenError = ({ onRetry }: ViewerTokenErrorProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  return (
    <Box role="alert" sx={styles.root}>
      <Typography variant="subtitle1" sx={styles.title}>The 3D view could not load.</Typography>
      <Typography variant="body2" sx={styles.detail}>
        The map service did not respond. Your project&apos;s files are still listed in the sidebar.
      </Typography>
      <Button variant="contained" onClick={onRetry} sx={styles.retryButton}>
        Retry
      </Button>
    </Box>
  );
};

export default ViewerTokenError;
